import React from "react";
import "../Assets/WebsiteCss/About.css";
import {
  FaAward,
  FaUsers,
  FaProjectDiagram,
  FaHandshake,
  FaLightbulb,
  FaCheckCircle,
  FaHeart,
  FaStar,
} from "react-icons/fa";

function About() {
  const stats = [
    {
      icon: <FaProjectDiagram />,
      number: "500+",
      label: "Projects Completed",
    },
    {
      icon: <FaUsers />,
      number: "300+",
      label: "Happy Clients",
    },
    {
      icon: <FaAward />,
      number: "15+",
      label: "Years Experience",
    },
    {
      icon: <FaStar />,
      number: "98%",
      label: "Client Satisfaction",
    },
  ];

  const values = [
    {
      icon: <FaLightbulb />,
      title: "Innovation",
      description:
        "We embrace cutting-edge design trends and construction technologies to deliver modern, future-ready spaces.",
    },
    {
      icon: <FaCheckCircle />,
      title: "Quality",
      description:
        "Excellence is our standard. We use premium materials and meticulous craftsmanship in every project.",
    },
    {
      icon: <FaHandshake />,
      title: "Integrity",
      description:
        "Transparent communication, honest pricing, and unwavering commitment to our promises.",
    },
  ];
  return (
    <div className="about-page">
      {/* HERO SECTION */}
      <section className="about-hero">
        <div className="about-hero-overlay" />
        <div className="about-hero-content">
          <h1 className="about-hero-title">
            Building Dreams
            <span className="about-highlight">Since 2010</span>
          </h1>
          <p className="about-hero-subtitle">
            With over 15 years of experience, we've transformed hundreds of
            spaces into stunning realities. Our passion for design and
            commitment to excellence drives everything we do.
          </p>
        </div>
      </section>

      {/* STATS SECTION */}
      <section className="about-stats-section">
        <div className="about-stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="about-stat-card">
              <div className="about-stat-icon">{stat.icon}</div>
              <div className="about-stat-number">{stat.number}</div>
              <div className="about-stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* STORY SECTION */}
      <section className="about-story-section">
        <div className="about-story-container">
          <div className="about-story-content">
            <h2 className="about-section-title">Our Story</h2>
            <p className="about-story-text">
              Founded in 2010, we started as a small team of passionate
              architects and designers with a simple belief: every space has the
              potential to be extraordinary. What began in a modest office has
              grown into a full-service design and construction firm, but our
              core values remain unchanged.
            </p>
            <p className="about-story-text">
              Today, we're proud to have completed over 500 projects, each one a
              testament to our dedication to quality, innovation, and client
              satisfaction. From residential homes to commercial spaces, we
              approach every project with the same enthusiasm and attention to
              detail that defined our very first build.
            </p>
            <p className="about-story-text">
              Our team has grown to include expert architects, interior
              designers, engineers, and craftsmen who share our passion for
              creating spaces that inspire. Together, we don't just build
              structures – we craft experiences, forge relationships, and help
              our clients bring their visions to life.
            </p>
          </div>
        </div>
      </section>

      {/* VALUES SECTION */}
      <section className="about-values-section">
        <div className="about-section-header">
          <h2 className="about-section-title">Our Core Values</h2>
          <p className="about-section-subtitle">
            The principles that guide every project we undertake
          </p>
        </div>

        <div className="about-values-grid">
          {values.map((value, index) => (
            <div key={index} className="about-value-card">
              <div className="about-value-icon">{value.icon}</div>
              <h3 className="about-value-title">{value.title}</h3>
              <p className="about-value-description">{value.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* WHY CHOOSE US SECTION */}
      <section className="about-why-section">
        <div className="about-why-container">
          <h2 className="about-section-title">Why Choose Us?</h2>
          <div className="about-why-grid">
            <div className="about-why-item">
              <FaCheckCircle className="about-why-icon" />
              <div>
                <h3>Expert Team</h3>
                <p>
                  Certified professionals with decades of combined experience
                </p>
              </div>
            </div>
            <div className="about-why-item">
              <FaCheckCircle className="about-why-icon" />
              <div>
                <h3>End-to-End Service</h3>
                <p>From concept to completion, we handle everything</p>
              </div>
            </div>
            <div className="about-why-item">
              <FaCheckCircle className="about-why-icon" />
              <div>
                <h3>Quality Materials</h3>
                <p>We use only premium, certified construction materials</p>
              </div>
            </div>
            <div className="about-why-item">
              <FaCheckCircle className="about-why-icon" />
              <div>
                <h3>Transparent Pricing</h3>
                <p>No hidden costs, clear quotes from day one</p>
              </div>
            </div>
            <div className="about-why-item">
              <FaCheckCircle className="about-why-icon" />
              <div>
                <h3>On-Time Delivery</h3>
                <p>We respect deadlines and deliver as promised</p>
              </div>
            </div>
            <div className="about-why-item">
              <FaCheckCircle className="about-why-icon" />
              <div>
                <h3>Post-Project Support</h3>
                <p>Our commitment doesn't end at handover</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="about-cta-section">
        <div className="about-cta-content">
          <h2 className="about-cta-title">Ready to Start Your Project?</h2>
          <p className="about-cta-subtitle">
            Let's bring your vision to life together
          </p>
          <div className="about-cta-buttons">
            <a href="/contact" className="about-btn-primary">
              Get in Touch
            </a>
            <a href="/projects" className="about-btn-secondary">
              View Our Work
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
